import HCaptcha from '@hcaptcha/react-hcaptcha';
import React from 'react';

import { handleSubmit } from 'src/viewLayer/components/nodes/InputNode/handleSubmit';
import {
  CaptchaComponentMapping,
  CaptchaParams,
  CaptchaComponentParams
} from 'src/viewLayer/components/nodes/InputNode/Captcha/types';
import { LOCALE } from 'src/dataLayer/env';
import { trackGuiShown } from 'src/dataLayer/remoteData/babbelEventStream';

const DEFAULT_PROVIDER = 'hcaptcha';

const HCaptchaWrapper = ({
  captchaRef,
  submitParams,
  sitekey
}: CaptchaComponentParams): JSX.Element =>
  <HCaptcha
    sitekey={ sitekey }
    onVerify={(token): Promise<void> => {
      trackGuiShown({ guiElementName: 'hcaptcha_completed' });
      return handleSubmit(submitParams, token);
    }}
    ref={ captchaRef }
    size="invisible"
    languageOverride={ LOCALE === 'en_GB' ? 'en' : LOCALE }
    onOpen={ (): void => trackGuiShown({ guiElementName: 'hcaptcha_shown' }) }
  />;

// Currently there is only a single hard-coded provider (hcaptcha), but we need to keep this flexible.
const CAPTCHA_PROVIDER_COMPONENT_MAPPING: CaptchaComponentMapping = {
  hcaptcha: HCaptchaWrapper
};

export const Captcha = ({
  captchaConfig,
  captchaRef,
  submitParams
}: CaptchaParams): JSX.Element | undefined => {
  if (!captchaConfig?.sitekey) return undefined;
  const provider = captchaConfig?.provider || DEFAULT_PROVIDER;
  const CaptchaComponent  = CAPTCHA_PROVIDER_COMPONENT_MAPPING[provider];
  return (
    <CaptchaComponent
      sitekey={ captchaConfig.sitekey }
      captchaRef={ captchaRef }
      submitParams={ submitParams }
    />
  );
};
